import {changeEvent, dispatchCustomEvent} from "../../../../../webpack/modules/events";
import {updateButtonsPrice} from "../../../../../webpack/modules-optimized/cart";

changeEvent('#product-popup input[name="tissue"]', true, function(element) {
    let container = element.closest('.product-scope');
    let option = element.closest('.product-option');
    let previewElement = option.querySelector('.option-preview');

    dispatchCustomEvent(
        'productTissueChanged',
        {
            'option': option,
            'previewElement': previewElement
        }
    );
    updateButtonsPrice(container);
});
